module.exports = __webpack_public_path__ + "fk.9144425b.svg";